module.exports = __webpack_public_path__ + "img/in-progress.7829aec0.svg";